// import { FunctionComponent, useEffect, useState } from "react";
// import styles from "./voicebot.module.css";

// const VoiceBot: FunctionComponent = () => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     setTimeout(() => setIsVisible(true), 100); // Delay to allow transition
//   }, []);

//   return (
//     <div className={`${styles.frameParent} ${isVisible ? styles.enterActive : styles.enter}`}>
//       <div className={styles.chakraVoiceBotParent}>
//         <div className={styles.chakraVoiceBot}>Chakra Voice Bot</div>
//         <div className={styles.humanLikeVoiceBotContainer}>
//           <p className={styles.humanLikeVoiceBot}>Human-like voice bot trained to be an effective and compliant collection manager.</p>
//           <p className={styles.humanLikeVoiceBot}>Experience the future of collections - Chakra</p>
//         </div>
//       </div>
//       <div className={styles.frameGroup}>
//         <div className={styles.image193Parent}>
//           <img className={styles.image193Icon} alt="" src="image 193.png" />
//           <div className={styles.sample1}>Sample 1</div>
//         </div>
//         <div className={styles.image193Parent}>
//           <img className={styles.image193Icon} alt="" src="image 194.png" />
//           <div className={styles.sample1}>Sample 2</div>
//         </div>
//         <div className={styles.image193Parent}>
//           <img className={styles.image193Icon} alt="" src="image 195.png" />
//           <div className={styles.sample1}>Sample 3</div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VoiceBot;
// import { FunctionComponent, useEffect, useState } from "react";
// import styles from "./voicebot.module.css";



// const VoiceBot: FunctionComponent = () => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     setTimeout(() => setIsVisible(true), 100);
//   }, []);
//   return (
//     <div className={`${styles.frameParent} ${isVisible ? styles.enterActive : styles.enter}`}>
//       <div className={styles.chakraVoiceBotParent}>
//         <div className={styles.chakraVoiceBot}>Chakra Voice Bot</div>
//         <div className={styles.humanLikeVoiceBotContainer}>
//           <p className={styles.humanLikeVoiceBot}>Human-like voice bot trained to be an effective and compliant collection manager.</p>
//           <p className={styles.humanLikeVoiceBot}>Experience the future of collections - Chakra</p>
//         </div>
//       </div>
//       <center>
//         <div className={styles.frameGroup}>
//           <div className={styles.audioSample}>
//             <audio controls>
//               <source src="/assets/audio2.wav" type="audio/mpeg" />
//               Your browser does not support the audio element.
//             </audio>
//             <div className={styles.sampleLabel}>Chakra Collection Officer</div>
//           </div>
//           <div className={styles.audioSample}>
//             <audio controls>
//               <source src="/assets/audio1.wav" type="audio/mpeg" />
//               Your browser does not support the audio element.
//             </audio>
//             <div className={styles.sampleLabel}>Chakra Reminder </div>
//           </div>
//           <div className={styles.audioSample}>
//             <audio controls>
//               <source src="/assets/audio.wav" type="audio/mpeg" />
//               Your browser does not support the audio element.
//             </audio>
//             <div className={styles.sampleLabel}>Chakra Payment Negotiator </div>
//           </div>
//         </div>
//       </center>
//       {/* <img  className={styles.pngwingcom1Icon} alt="" src="./assets/wave.png" /> */}

//       <div className={styles.smarterScalableAnd}>Smarter, Scalable, and Effortlessly Efficient</div>
//     </div>
//   );
// };

// export default VoiceBot;
import { FunctionComponent, useEffect, useRef, useState } from "react";
import styles from "./voicebot.module.css";

const VoiceBot: FunctionComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const currentlyPlayingRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  // Attach play event listener to each audio element
  const handleAudioPlay = (event: React.SyntheticEvent<HTMLAudioElement>) => {
    if (currentlyPlayingRef.current && currentlyPlayingRef.current !== event.currentTarget) {
      currentlyPlayingRef.current.pause();
      currentlyPlayingRef.current.currentTime = 0;
    }
    currentlyPlayingRef.current = event.currentTarget;
  };

  return (
    <div className={`${styles.frameParent} ${isVisible ? styles.enterActive : styles.enter}`}>
      <div className={styles.chakraVoiceBotParent}>
        <div className={styles.chakraVoiceBot}>Chakra Voice Bot</div>
        <div className={styles.humanLikeVoiceBotContainer}>
          <p className={styles.humanLikeVoiceBot}>Human-like voice bot trained to be an effective and compliant collection manager.</p>
          <p className={styles.humanLikeVoiceBot}>Experience the future of collections - Chakra</p>
        </div>
      </div>
      <center>
        <div className={styles.frameGroup}>
          <div className={styles.audioSample}>
            <audio controls onPlay={handleAudioPlay} className={styles.audio}>
              <source src="/assets/audio2.wav" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
            <div className={styles.sampleLabel}>Chakra Collection Officer</div>
          </div>
          <div className={styles.audioSample}>
            <audio controls onPlay={handleAudioPlay} className={styles.audio}>
              <source src="/assets/audio1.wav" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
            <div className={styles.sampleLabel}>Chakra Reminder</div>
          </div>
          <div className={styles.audioSample}>
            <audio controls onPlay={handleAudioPlay} className={styles.audio}>
              <source src="/assets/audio.wav" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
            <div className={styles.sampleLabel}>Chakra Payment Negotiator</div>
          </div>
        </div>
      </center>

      <div className={styles.smarterScalableAnd}>Smarter, Scalable, and Effortlessly Efficient</div>
    </div>
  );
};

export default VoiceBot;
